import axios from '../utilities/axios'

const RC_TOKEN = 'rc_token'

function saveUserToken(payload) {
  return localStorage.setItem(RC_TOKEN, payload)
}

function getUserToken() {
  const token = localStorage.getItem(RC_TOKEN)
  return token
}

function removeUserToken() {
  return localStorage.removeItem(RC_TOKEN)
}

async function verifyUserToken(token) {
  try {
    await axios.post('/api/v1/rc/token/verify', { token })
    return true
  } catch {
    return false
  }
}

async function activateGame(token, couponCode, contentId, activationKey) {
  try {
    await axios.post('/api/v1/rc/content/activate', { token, activationKey, contentId, couponCode })
    return { status: 200 }
  } catch (error) {
    return error
  }
}

export default {
  saveUserToken,
  getUserToken,
  removeUserToken,
  verifyUserToken,
  activateGame,
}
